import { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, CaretDown, CaretUp } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { motion, AnimatePresence } from 'framer-motion';

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'O que é o PasseioPerfeito?',
      answer: 'O PasseioPerfeito é uma plataforma que conecta donos de cães e gatos com pet sitters e passeadores de cães de confiança em Portugal. Não somos uma empresa de pet sitting - funcionamos como um marketplace que facilita o encontro entre quem precisa de cuidados para os seus animais e quem oferece esses serviços.'
    },
    {
      question: 'Quanto custa usar a plataforma?',
      answer: 'Para clientes (donos de animais), a plataforma é 100% gratuita. Pode pesquisar prestadores, enviar pedidos e usar o chat sem qualquer custo. Os prestadores podem usar gratuitamente com limite de 2 contactos/mês, ou escolher o Plano Pro (4,99€/mês para contactos ilimitados) ou Pay-per-Contacto (4€ por cada contacto).'
    },
    {
      question: 'Como sei se um prestador é de confiança?',
      answer: 'Recomendamos verificar: avaliações de outros clientes, fotos do perfil, se tem verificação de identidade (badge verificado), a descrição e experiência mencionada. Aconselhamos sempre a conhecer o prestador pessoalmente antes de lhe confiar o seu animal. O PasseioPerfeito não verifica independentemente todos os prestadores.'
    },
    {
      question: 'Como funciona a verificação de identidade?',
      answer: 'Os prestadores podem submeter um documento de identificação é uma selfie para verificação. Após aprovação, recebem um badge de "Verificado" no perfil. Esta verificação confirma a identidade, mas não garante a qualidade do serviço.'
    },
    {
      question: 'Que serviços posso encontrar?',
      answer: 'Na plataforma encontra: Passeios diários (passeios regulares para cães), Hospedagem (cuidado 24h em casa do pet sitter), Visitas ao domicílio (alimentar e brincar na sua casa), e Dog Sitting (cuidados durante viagens ou ausências prolongadas).'
    },
    {
      question: 'Como funciona o pagamento?',
      answer: 'Os pagamentos são acordados diretamente entre cliente e prestador. Pode pagar em dinheiro, transferência ou pelos métodos disponíveis na plataforma (cartão via Stripe ou MB Way). O PasseioPerfeito não cobra comissão sobre os serviços.'
    },
    {
      question: 'E se houver um problema durante o serviço?',
      answer: 'Qualquer problema deve ser resolvido diretamente entre o cliente é o prestador. O PasseioPerfeito é apenas uma plataforma de conexão e não se responsabiliza por incidentes, danos ou incumprimentos. Recomendamos que os prestadores tenham seguro de responsabilidade civil.'
    },
    {
      question: 'Posso cancelar um pedido?',
      answer: 'As políticas de cancelamento são definidas por cada prestador. Antes de confirmar um pedido, discuta com o prestador os termos de cancelamento. Geralmente, cancelamentos com antecedência razoável são aceites sem penalização.'
    },
    {
      question: 'Como me torno um prestador?',
      answer: 'É simples: crie uma conta, selecione "Quero ser Prestador", complete o seu perfil com fotos, serviços e preços, escolha as suas zonas de atuação e comece a receber pedidos. Pode verificar a sua identidade para aumentar a confiança.'
    },
    {
      question: 'O que é a Oferta de Lançamento?',
      answer: 'Os primeiros 10 prestadores em cada cidade ganham 3 meses de Plano Pro completamente grátis! Assim podem receber contactos ilimitados e ter destaque na plataforma sem qualquer custo durante os primeiros meses.'
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="container mx-auto px-4 py-8 max-w-3xl">
        <Link to="/">
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar
          </Button>
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="text-3xl font-bold font-outfit mb-4">Perguntas Frequentes</h1>
          <p className="text-lg text-muted-foreground mb-12">
            Respostas às dúvidas mais comuns sobre o PasseioPerfeito
          </p>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <Card key={faq.question} className="overflow-hidden">
                <CardContent className="p-0">
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-muted/50 transition-colors"
                    data-testid={`faq-${index}`}
                  >
                    <span className="font-medium pr-4">{faq.question}</span>
                    {openIndex === index ? (
                      <CaretUp className="w-5 h-5 flex-shrink-0 text-primary" />
                    ) : (
                      <CaretDown className="w-5 h-5 flex-shrink-0 text-muted-foreground" />
                    )}
                  </button>
                  <AnimatePresence>
                    {openIndex === index && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.2 }}
                      >
                        <div className="px-6 pb-4 pt-0">
                          <p className="text-muted-foreground">{faq.answer}</p>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Contact CTA */}
          <div className="mt-12 text-center bg-muted/50 rounded-2xl p-8">
            <h2 className="text-xl font-semibold mb-2">Não encontrou a sua resposta?</h2>
            <p className="text-muted-foreground mb-4">
              Entre em contacto connosco e teremos todo o gosto em ajudar.
            </p>
            <Link to="/contactos">
              <Button className="rounded-full">
                Contactar-nos
              </Button>
            </Link>
          </div>
        </motion.div>
      </main>

      <Footer />
    </div>
  );
}
